



































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { map } from 'lodash';

import { Category, ObjectType } from '../types';

export default Vue.extend({
  name: 'ToDoListInvalidState',
  data() {
    return {
      punctuationMarks: [',', ', or', '?'] as Array<string>,
    };
  },
  computed: {
    ...mapGetters(['modelMeta']),
    ...mapGetters('todoList', ['isInvalidCategoryState', 'objectTypes', 'category']),
    objectTypesLinks() {
      const category = this.isInvalidCategoryState ? Category.Todo : this.category;

      const mapToTemplate = (objectType: ObjectType) => {
        const meta = this.modelMeta[objectType];

        return {
          title: meta.titlePlural,
          linkTo: { name: 'toDoList', params: { category, objectType: meta.humanPlural } },
        };
      };

      return map(this.objectTypes, mapToTemplate);
    },
  },
  methods: {
    getPunctuationMark(i: number): string {
      return this.punctuationMarks[i];
    },
  },
});
